import { ref } from 'vue';

const isAccessDeniedModalVisible = ref<boolean>(false);
const accessDeniedMessage = ref<string>('');

const useAccessDenied = () => {
  const showAccessDeniedModal = () => {
    isAccessDeniedModalVisible.value = true;
  };

  const hideAccessDeniedModal = () => {
    isAccessDeniedModalVisible.value = false;
  };

  const setAccessDeniedMessage = (message: string) => {
    accessDeniedMessage.value = message;
  };

  return {
    isAccessDeniedModalVisible,
    showAccessDeniedModal,
    hideAccessDeniedModal,
    accessDeniedMessage,
    setAccessDeniedMessage,
  };
};

export default useAccessDenied;
